import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser, isPlatformServer} from "@angular/common";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class LogService {

    platformId: any;
    constructor(@Inject(PLATFORM_ID) platformId: any) {
      this.platformId = platformId;
    }
    platform(){
      if(isPlatformBrowser(this.platformId)){
        return "Browser";
      }
      if(isPlatformServer(this.platformId)){
        return "Server";
      }
      return "";
    }

    log(log: string){
      if(!environment.production){
        return console.log(this.platform(),log);
      }
    }

    info(log: string){
      if(!environment.production) {
        return console.info(this.platform(), log);
      }
    }


    logService(log: string){
      if(!environment.production) {
        return this.log('🔧 Service : ' + log);
      }
    }

    logTracker(event: string, path: string, pageName: string){
      if(!environment.production) {
        return this.log('📈 Analytics : ' + event + ' : ' + path + ' : ' + pageName);
      }
    }

    logNotTracker(event: string, path: string, pageName: string){
      if(!environment.production) {
        return this.log('📈 Not consent to Track : ' + event + ' : ' + path + ' : ' + pageName);
      }
    }

    logSignalR(log:string){
        const message = "📡️🟢 SignalR : " + log;
        return console.trace(this.platform(),message);
    }

    logSignalRError(log:string){
      const message = "📡🔴 SignalR : " + log;
        return console.error(this.platform(),message);
    }

    logHttpCallback(log:string, response?: any){
      if(!environment.production) {
        let logApiRes = "";
        if (response !== undefined) {
          logApiRes = response.success !== false ? ": OK" : ": NOK (" + response.detail + ")";
        }
        return console.info(this.platform(), "🌐️🟢 API :", log, logApiRes);
      }
    }

    logHttpCallbackError(log:string){
      if(!environment.production) {
        return console.error(this.platform(), "🌐🔴 API : ", log);
      }
    }

    logAlgoliaError(log:string){
      if(!environment.production) {
        return console.error(this.platform(), "🔍🔴 Algolia : ", log);
      }
    }

    logSession(log:string){
        return console.info(this.platform(),"🕒 Session :",log);
    }

    logInteraction(log:string){
        return this.log("🖐️ Touch/Click : "+log);
    }

    logInput(log:string){
        return this.log("⌨️️ Input : "+log);
    }

    logMaintenance(log: string){
        return console.warn(this.platform(),"⚡️️ Maintenance :",log);
    }

}
